import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-route",
  "use": "icon-ic-route-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-route\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 7c0 2.21-4 7-4 7S2 9.21 2 7a4 4 0 1 1 8 0ZM8 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm12 0a2 2 0 1 0-1.732-3H15a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7.732a2 2 0 1 0 0 2H18a3 3 0 0 0 3-3v-3a3 3 0 0 0-3-3h-3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h3.268A2 2 0 0 0 20 7Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol